import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Widgets.css'
import { Card, CardBody, Row, Col } from "reactstrap";
import Icon from "@mdi/react";
import { mdiAccountCancel ,mdiAccount} from "@mdi/js";
import { use } from 'react';
import { set } from 'lodash';

const API = process.env.REACT_APP_API;

const Miniwidget = () => {
    const [genero, setGenero] = useState([]);
    const [total, setTotal] = useState(0);


    useEffect(() => {
        const fetchGenero = async () => {
            try {
                const response = await axios.get(`${API}/api/members/generos`);
                const generoData = response.data.map(genero => ({
                    genero: genero._id,
                    cantidad: genero.total
                }));

                setGenero(generoData);
            } catch (error) {
                console.error("Error fetching genero:", error);
            }
        };

        fetchGenero();
    }, []);

    useEffect(() => {
        const fetchTotal = async () => {
            try {
                const response = await axios.get(`${API}/api/members/totales`);
                setTotal(response.data);  // Asigna directamente el objeto recibido
            } catch (error) {
                console.error("Error fetching total:", error);
            }
        };
    
        fetchTotal();
    
    }, []);



  return (
    <React.Fragment>
      <Row>
        <Col xl={3} sm={6}>
          <Card className="mini-stat bg-primary">
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
               
              <i className={"float-end mdi mdi-account-check" }></i>

              </div>
              <div className="text-white">
                <h6 className="text-uppercase mb-3 font-size-16 text-white">Socios Totales</h6>
                <h2 className="mb-4 text-white">Total  {total.totalSocios} </h2>
                <span className="badge bg-info"> average </span> <span className="ms-2">From previous period</span>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card className="mini-stat bg-danger">
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
              <i className={"float-end mdi mdi-account-alert" }></i>

              </div>
              <div className="text-white">
                <h6 className="text-uppercase mb-3 font-size-16 text-white">Socios en Mora</h6>
                <h2 className="mb-4 text-white">Total  {total.totalSocios} </h2>
                <span className="badge bg-rojo"> average </span> <span className="ms-2">From previous period</span>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card className="mini-stat bg-azul">
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
               
              <i className={"float-end mdi mdi-human-male" }></i>
              </div>
              <div className="text-white">
                <h6 className="text-uppercase mb-3 font-size-16 text-white">Socios Masculino</h6>
                    <h2 className="mb-4 text-white">
                            Total: {genero.find(g => g.genero === "masculino")?.cantidad || 0}
                    </h2>
                <span className="badge bg-info"> average </span> <span className="ms-2">From previous period</span>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card className="mini-stat bg-rosa">
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
               
              <i className={"float-end mdi mdi-human-female" }></i>

              </div>
              <div className="text-white">
                <h6 className="text-uppercase mb-3 font-size-16 text-white">Socios Femeninos</h6>
                    <h2 className="mb-4 text-white">
                            Total: {genero.find(g => g.genero === "femenino")?.cantidad || 0}
                    </h2>
                <span className="badge bg-info"> average </span> <span className="ms-2">From previous period</span>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Miniwidget;
